export default __webpack_public_path__ + "static/media/js.b0f6990a.png";